import React from "react";
import Size from "../../assets/images/size-chart.jpeg";
const SizeChart = () => {
  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-2xl font-bold text-center mb-6">Size Chart</h1>
      <div className="w-1/2 mx-auto flex justify-center">
        <img
          src={Size} // Replace with your actual size chart image
          alt="TYKA Size Chart"
          className="ml-8 mr-0 h-auto shadow-md rounded-lg"
        />
      </div>
    </div>
  );
};

export default SizeChart;
